// Components
import ImageZoom from '../components/imageZoom';
import SdsHelper from '../helpers/sds-helper';
import QueryStringHelper from '../helpers/query-string-helper';
import DemoForm from '../forms/request-demo';

// Templates
import productGallery from '../templates/product-gallery-slider.hbs';
import contentNav from '../templates/product-content-nav.hbs';
import contentSections from '../templates/product-content-sections.hbs';

export default class ProductDetail {
    constructor() {
        // console.log('ProductDetail.constructor()');

        this.state = {
            activeSKU: 0,
            frenchLanguage: false,
            post: {},
            slickSettings: {
                gallery: {
                    rows: 0,
                    infinite: true,
                    slidesToShow: 1,
                    slidesToScroll: 1,
                    dots: true,
                    arrows: false,
                },
                nav: {
                    rows: 0,
                    infinite: true,
                    slidesToShow: 7,
                    slidesToScroll: 1,
                    dots: false,
                    arrows: true,
                    variableWidth: true, // allow css override of slide width
                },
            },
        };

        // detect the language of page
        // in the page loaded state
        // note: this const is defined in the fetchPost function,
        // but didn't want to fuss with global variables -- rg
        const lang = $('html').attr('lang');
        if (lang == 'fr-CA') {
            this.state.frenchLanguage = true;
        } else {
            this.state.frenchLanguage = false;
        }

        this.render();
        this.initListeners();
        new DemoForm();
    }

    initListeners() {
        // console.log('ProductDetail.initListeners()');

        // should be one of the links for a product
        $('.js-view-sds').on('click', async (e) => {
            e.preventDefault();

            const sdsId = this.state.post.acf.skus[this.state.activeSKU].tcc_sds_id;
            SdsHelper.openSds(sdsId);
        });

        // Check url var to open accordion
        if (window.location.hash != '') {
            // remove any accordion panels that are showing (they have a class of 'in')
            $('.collapse').removeClass('in');

            // show the panel based on the hash now:
            $(`${window.location.hash}.collapse`).collapse('show');
        }
    }

    async fetchPost() {
        // console.log('ProductDetail.fetchPost()');

        const slug = $('body').attr('id');
        const lang = $('html').attr('lang');
        let locale = '';
        if (lang == 'fr-CA') {
            locale = 'fr/';
        }

        try {
            const response = await fetch(`/${locale}wp-json/wp/v2/cp_product?slug=${slug}&acf_format=standard`, {
                credentials: 'same-origin',
            });
            const json = await response.json();
            Object.assign(this.state.post, json[0]);
            if (Electro.Debug) {
                console.log(this.state.post);
            }
        } catch (error) {
            console.error('Failed to get products.', error);
        }
    }

    initNavSlider() {
        // console.log('ProductDetail.initNavSlider()');
        $('.slick-slider.slider--product-nav').slick(this.state.slickSettings.nav);

        // click thumbnails
        $('.slick-slide .product-link').on('click', (e) => {
            e.preventDefault();
            const $target = $(e.currentTarget);
            const skuIndex = $target.attr('data-index');
            const $slideshow = $target.closest('.slick-slider');
            const $slide = $target.closest('.slick-slide');
            const slideIndex = $slide.attr('data-slick-index');
            // $slideshow.slick('slickGoTo', parseInt(slideIndex, 10));
            $('.product-link').removeClass('active');
            $(`.product-link[data-index="${skuIndex}"]`).addClass('active');
            $('html, body').animate({ scrollTop: $('header').outerHeight() }, 400);
            this.state.activeSKU = skuIndex;
            this.reInit();
        });

        const upc = QueryStringHelper.get('upc');
        if (upc) {
            $('.slick-slide').find(`[data-upc="${upc}"]`).click();
        }
    }

    initProductGallery() {
        // console.log('ProductDetail.initProductGallery()');
        $('.slick-slider.slider--gallery').slick(this.state.slickSettings.gallery);
        // Navigate by label
        $('.slider__nav .nav__item').on('click', function (e) {
            e.preventDefault();
            $(this).closest('.slider__nav').find('.nav__item').removeClass('active');
            $(this).addClass('active');
            $(this).closest('.slideshow-wrapper').find('.slick-slider').slick('slickGoTo', $(this).attr('data-slide'));
        });

        $('.slideshow-wrapper .slick-slider').on('beforeChange', function (event, slick, currentSlide, nextSlide) {
            const $container = $(this).closest('.slideshow-wrapper');
            $container.find('.slider__nav .nav__item').removeClass('active');
            $container.find(`.slider__nav li:eq(${nextSlide}) .nav__item`).addClass('active');
        });

        $('.toggle-zoom').click(function (e) {
            e.preventDefault();
            $(this).parent().addClass('zoom-active');
            $(this).parent().find('.zoom-container').show();
            const zoomer = new ImageZoom($(this), $(this).parent().find('.zoom-container'));
            zoomer;
        });

        $('.zoom-container').click(function (e) {
            e.preventDefault();
            $(this).parent().removeClass('zoom-active');
            $(this).parent().find('.img-zoom-lens').remove();
            $(this).hide();
        });
    }

    initStickyNav() {
        // console.log('ProductDetail.initStickyNav()');

        const $navbar = $('#sticky-nav');
        // const $hero = $('.hero');
        const $hero = $('.hero .page-title');
        const offset = $hero.offset();

        const sticky = offset.top + $hero.outerHeight();

        function stickyNav() {
            if (window.pageYOffset >= sticky && !$('.product-selector__form').is(':visible')) {
                $navbar.addClass('active');
            } else {
                $navbar.removeClass('active');
            }
        }

        window.onscroll = function doStickyNav() {
            stickyNav();
        };

        $navbar.hover(() => {
            if ($navbar.find('.dropdown').length > 0) {
                $navbar.find('.dropdown').toggleClass('open');
                $navbar.find('.image-wrapper--active').toggleClass('hidden');
            }
        });

        $('.product-selector__current').click((e) => {
            e.preventDefault();
            $navbar.removeClass('active');
            $('.header--product-selector').find('.product-selector__form').show();
        });
    }

    initSKUSelector() {
        // console.log('ProductDetail.initSKUSelector()');

        $('.product-selector__form li').click((e) => {
            e.preventDefault();
            const el = $(e.currentTarget);
            el.parent().find('li').removeClass('active');
            el.addClass('active');
            el.closest('.product-selector__form').hide();
            this.state.activeSKU = el.attr('data-index');
            $('html, body').animate({ scrollTop: $('header').outerHeight() }, 400);
            this.reInit();
        });
        $('.product-selector__form .close').click(function (e) {
            e.preventDefault();
            $(this).closest('.product-selector__form').hide();
        });
    }

    async render() {
        // console.log('ProductDetail.render()');

        await this.fetchPost();

        if (Electro.Debug) {
            console.log('Product Detail: Render');
        }
        window.state = this.state;

        this.initNavSlider();
        this.initStickyNav();
        this.initSKUSelector();
        this.reInit();

        // if(window.location.hash) {
        //   console.log('Hash:');
        //   console.log(window.location.hash);
        //   $(`.nav-link[href="${window.location.hash}"]`).trigger('click');
        // }
    }

    reInit() {
        const activeSKU = Object.assign(this.state.post.acf.skus[this.state.activeSKU], {
            new: this.state.post.acf.new,
            frenchLanguage: this.state.frenchLanguage,
        });

        if (Electro.Debug) {
            console.info('SKU: ', activeSKU);
        }

        $('.loading-indicator').hide();

        // render templates
        $('.gallery-wrapper').html(productGallery(activeSKU));

        // Update section nav
        $('.nav--layouts').find('.nav-item--sku-section').remove();
        $('.nav--layouts').prepend(contentNav(activeSKU));

        // Update section layouts
        $('.js-content-sections').find('.sku-section').remove();
        $('.js-content-sections').prepend(contentSections(activeSKU));

        // update individual elements
        $('.product-title').html(activeSKU.sku_name);
        $('#sticky-nav .img--active-product').css('background-image', `url(${activeSKU.gallery[0].image})`);

        if (activeSKU.tcc_sds_id) {
            $('.js-view-sds').removeClass('hidden');
        } else {
            $('.js-view-sds').addClass('hidden');
        }

        $('body').scrollspy('refresh');

        $('.lazy').Lazy(window.lazyOptions);

        this.targetingCookies = window.OptanonActiveGroups && !!(window.OptanonActiveGroups.indexOf('C0004') >= 0);

        if( $('.js-content-sections').find('.layout-module_video').length > 0 ) {
            if (!this.targetingCookies) {
                $('.js-content-sections').find('.layout-module_video').each((index, element) => {
                    const $container = $(element);
                    $container.find('.consent-message').removeClass('hidden');
                    $container.find('.video-container').remove();
                });
            }
        }

        this.initProductGallery();

        /**
         * There is a really weird behavior where #section-related-products and #section-related-resources anchors
         * don't set the navbar selection correctly (they are misplaced by one item behind it's intended selection)
         * There is definitely a race condition where nav element #section-related-products and #section-related-resources
         * are always loaded first, and rest of the sections are appended later, which seems to be causing that
         * race condition. In order to mitigate this, the handling of the anchor will be triggered with a delay
         * (unfortunately, there was no good workaround with the given amount of time)
         */
        $(document).ready(() => {
            setTimeout(() => {
                const $sidebarElements = $('#content-nav ul li a');

                if ($sidebarElements.length) {
                    $sidebarElements.each(function () {
                        if ($(this)[0].hash === window.location.hash) {
                            $(this).trigger('click');
                        }
                    });
                }
            }, 250);
        });
    }
}
